import React from 'react';
import T from 'prop-types';
// styles
import styles from './Stepper.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const Stepper = ({ value }) => {
  if (value === undefined) {
    value = -1;
  }

  return (
    <div className={styles.stepperWrapper}>
      <div className={cn(styles.stepper, value)} style={{ transform: `translateX(${-60 * value}px)` }}>
        <div className={cn(styles.step, { active: value === 0 })}>1</div>
        <div className={cn(styles.step, { active: value === 1 })}>2</div>
        <div className={cn(styles.step, { active: value === 2 })}>3</div>
        <div className={cn(styles.step, { active: value === 3 })}>4</div>
      </div>
    </div>
  );
};

Stepper.propTypes = {
  value: T.oneOf([0, 1, 2, 3])
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/containers/SignUp/components/Stepper/Stepper.jsx